import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PagedData } from '../models/BaseResponse';
import { LicenseSearchCriteria } from '../models/searchCriteria/LicenseSearchCriteria';
import { License } from '../models/License';

@Injectable({
  providedIn: 'root'
})
export class LicenseService {


  constructor(private httpClient: HttpClient) { }

  find(searchCriteria: LicenseSearchCriteria): Observable<PagedData<License>> {
    return this.httpClient.post<PagedData<License>>(environment.apiUrl + "licenses/filtered",searchCriteria);
  }

  get(id: number): Observable<License> {
    return this.httpClient.get<License>(environment.apiUrl + "licenses/" + id);
  }

  save(license: License): Observable<void> {
    if (license.id == 0 || license.id === undefined) {
      return this.httpClient.post<void>(environment.apiUrl + "licenses", license);
    }
    else {
      return this.httpClient.put<void>(environment.apiUrl + "licenses/" + license.id, license);
    }
  }
 
  delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(environment.apiUrl + "licenses/" + id);
  }
}  